import { Box, Paper } from "@mui/material";
import { FormattedMessage } from "react-intl";

import { RichTextDisplay } from "@dzambalaorg/mui-rte";
import { AddressLink } from "@dzambalaorg/mui-scanner";
import { ContractFeatures, IToken } from "@framework/types";
import { shouldShowAttributes, TokenAttributesView } from "@framework/shared";
import { Table } from "@dzambalaorg/ui-kit";

import { TokenTraitsView } from "../../traits";

export interface ICollectionTokenDialogViewProps {
  viewItem: IToken | null;
}

export const CollectionTokenDialogView = (props: ICollectionTokenDialogViewProps) => {
  const { viewItem } = props;

  const { template, tokenId, metadata, balance, imageUrl } = viewItem || {};

  const showAttributes = shouldShowAttributes(metadata);

  return (
    <Table.Container component={Paper}>
      <Table aria-label="table">
        <Table.Body>
          <Table.Row>
            <Table.Cell component="th" scope="row">
              <FormattedMessage id="form.labels.tokenId" />
            </Table.Cell>
            <Table.Cell align="right">{tokenId}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell component="th" scope="row">
              <FormattedMessage id="form.labels.title" />
            </Table.Cell>
            <Table.Cell align="right">{template?.title}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell component="th" scope="row">
              <FormattedMessage id="form.labels.description" />
            </Table.Cell>
            <Table.Cell align="right">
              <RichTextDisplay data={template?.description} />
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell component="th" scope="row">
              <FormattedMessage id="form.labels.contract" />
            </Table.Cell>
            <Table.Cell align="right">{template?.contract?.title}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell component="th" scope="row">
              <FormattedMessage id="form.labels.address" />
            </Table.Cell>
            <Table.Cell align="right">{template?.contract?.address}</Table.Cell>
          </Table.Row>
          {showAttributes && (
            <Table.Row>
              <Table.Cell component="th" scope="row">
                <FormattedMessage id="form.labels.metadata" />
              </Table.Cell>
              <Table.Cell align="right">
                <TokenAttributesView metadata={metadata} />
              </Table.Cell>
            </Table.Row>
          )}
          {template?.contract?.contractFeatures.includes(ContractFeatures.TRAITS) ? (
            <Table.Row>
              <Table.Cell component="th" scope="row">
                <FormattedMessage id="form.labels.traits" />
              </Table.Cell>
              <Table.Cell align="right">
                <TokenTraitsView metadata={metadata} />
              </Table.Cell>
            </Table.Row>
          ) : null}
          <Table.Row>
            <Table.Cell component="th" scope="row">
              <FormattedMessage id="form.labels.account" />
            </Table.Cell>
            <Table.Cell align="right">
              <AddressLink address={balance?.at(0)?.account} />
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell component="th" scope="row">
              <FormattedMessage id="form.labels.imageUrl" />
            </Table.Cell>
            <Table.Cell align="right">
              <Box component="img" sx={{ maxWidth: "100%" }} src={imageUrl || ""} alt={template?.title} />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    </Table.Container>
  );
};
